import React, { useEffect, useState, useRef } from 'react';
import { Line } from 'react-chartjs-2';
import { io } from 'socket.io-client';
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'https://pochelo.online';
const socket = io(SOCKET_URL);

const UMBRAL_AMPERAJE = 50;
const COLOR_ALERTA_PUNTO = 'red';
const RADIO_PUNTO_NORMAL = 2;
const RADIO_PUNTO_ALERTA = 4;
const SONIDO_ALERTA_PATH = '/alerta.mp3';

const LineChart2 = () => {
    const [chartData, setChartData] = useState({
        labels: Array.from({ length: 15 }, (_, i) => i + 1),
        datasets: [],
    });
    const [alertaActiva, setAlertaActiva] = useState({});
    const audioPlayer = useRef(null);

    useEffect(() => {
        audioPlayer.current = new Audio(SONIDO_ALERTA_PATH);
        audioPlayer.current.load();

        const dataMap = JSON.parse(localStorage.getItem('dataMap2')) || {};
        const colorMap = JSON.parse(localStorage.getItem('colorMap2')) || {};
        const colors = ['rgb(121, 14, 221)', 'rgb(68, 233, 178)', 'rgb(117, 104, 230)', 'rgb(129, 128, 71)'];
        // Colores solicitados para máquinas 5..8 - Gama azul pastel
        const colorPorMaquina = {
           5: '#0d3949ff',    // azul pastel claro
            6: '#1874a5ff',    // azul pastel medio
            7: '#5bdb61ff',    // azul pastel
            8: '#3b728bff',    // azul pastel oscuro
        };

        const updateChartData = () => {
            const datasets = Object.keys(dataMap).map((key) => {
                const datosMaquina = dataMap[key] || [];
                const match = key.match(/\d+/);
                const num = match ? parseInt(match[0], 10) : null;
                const colorLinea = (num && colorPorMaquina[num]) ? colorPorMaquina[num] : '#B8F1FF';
                const pointBackgroundColors = datosMaquina.map(valor =>
                    valor > UMBRAL_AMPERAJE ? COLOR_ALERTA_PUNTO : colorLinea
                );
                const pointRadii = datosMaquina.map(valor =>
                    valor > UMBRAL_AMPERAJE ? RADIO_PUNTO_ALERTA : RADIO_PUNTO_NORMAL
                );

                return {
                    label: ` ${key}`,
                    data: datosMaquina,
                    fill: false,
                    borderColor: colorLinea,
                    tension: 0.6,
                    pointRadius: pointRadii,
                    pointHoverRadius: RADIO_PUNTO_ALERTA + 2,
                    borderWidth: window.innerWidth < 600 ? 0.8 : 1.5,
                    pointBackgroundColor: pointBackgroundColors,
                };
            });

            setChartData({
                labels: Array.from({ length: 15 }, (_, i) => i + 1),
                datasets,
            });
        };

        updateChartData();

        socket.on('mqttData2', (data) => {
            const { maquinaId, amperaje } = data;

            if (typeof amperaje !== 'number') {
                console.warn(`Amperaje no es un número para ${maquinaId}:`, amperaje);
                return;
            }

            const match = maquinaId.match(/\d+/);
            if (!match || !match[0]) {
                console.warn(`No se pudo extraer maquinaIdNum de ${maquinaId}`);
                return;
            }
            const maquinaIdNum = parseInt(match[0], 10);

            if (maquinaIdNum >= 5 && maquinaIdNum <= 8) {
                if (!dataMap[maquinaId]) {
                    dataMap[maquinaId] = Array(15).fill(0);
                    colorMap[maquinaId] = colors[Object.keys(colorMap).length % colors.length];
                }

                dataMap[maquinaId].push(amperaje);
                if (dataMap[maquinaId].length > 15) {
                    dataMap[maquinaId].shift();
                }

                if (amperaje > UMBRAL_AMPERAJE) {
                    if (!alertaActiva[maquinaId]) {
                        alert(`¡Alerta! ${maquinaId} ha superado el umbral de amperaje: ${amperaje}A`);
                        if (audioPlayer.current) {
                            audioPlayer.current.play().catch(error => console.error("Error al reproducir sonido:", error));
                        }
                        setAlertaActiva(prev => ({ ...prev, [maquinaId]: true }));
                    }
                } else {
                    if (alertaActiva[maquinaId]) {
                        setAlertaActiva(prev => ({ ...prev, [maquinaId]: false }));
                    }
                }

                localStorage.setItem('dataMap2', JSON.stringify(dataMap));
                localStorage.setItem('colorMap2', JSON.stringify(colorMap));
                updateChartData();
            }
        });

        // Listener para Machine8 por mqttMachine8
        socket.on('mqttMachine8', (data) => {
            const { maquinaId, amperaje } = data;

            if (typeof amperaje !== 'number') {
                console.warn(`Amperaje no es un número para ${maquinaId}:`, amperaje);
                return;
            }

            if (maquinaId === 'Machine8') {
                if (!dataMap[maquinaId]) {
                    dataMap[maquinaId] = Array(15).fill(0);
                    colorMap[maquinaId] = colors[Object.keys(colorMap).length % colors.length];
                }

                dataMap[maquinaId].push(amperaje);
                if (dataMap[maquinaId].length > 15) {
                    dataMap[maquinaId].shift();
                }

                if (amperaje > UMBRAL_AMPERAJE) {
                    if (!alertaActiva[maquinaId]) {
                        alert(`¡Alerta! ${maquinaId} ha superado el umbral de amperaje: ${amperaje}A`);
                        if (audioPlayer.current) {
                            audioPlayer.current.play().catch(error => console.error("Error al reproducir sonido:", error));
                        }
                        setAlertaActiva(prev => ({ ...prev, [maquinaId]: true }));
                    }
                } else {
                    if (alertaActiva[maquinaId]) {
                        setAlertaActiva(prev => ({ ...prev, [maquinaId]: false }));
                    }
                }

                localStorage.setItem('dataMap2', JSON.stringify(dataMap));
                localStorage.setItem('colorMap2', JSON.stringify(colorMap));
                updateChartData();
            }
        });

        return () => {
            socket.off('mqttData2');
            socket.off('mqttMachine8');
            if (audioPlayer.current) {
                audioPlayer.current.pause();
                audioPlayer.current.src = '';
            }
        };
    }, [alertaActiva]);

    const options = {
        maintainAspectRatio: false,
        scales: {
            x: {
                grid: { color: 'rgba(123, 104, 238, 0.3)' },
                ticks: { color: '#FFFFFF', padding: 10, font: { family: 'Roboto', size: 12, weight: '300' } }
            },
            y: {
                min: 0, max: 60,
                grid: { color: 'rgba(123, 104, 238, 0.3)' },
                ticks: { color: '#FFFFFF', padding: 10, font: { family: 'Roboto', size: 12, weight: '300' } }
            }
        },
        plugins: {
            legend: {
                labels: {
                    color: '#FFFFFF',
                    font: { family: 'Roboto', size: 12, weight: '300' }
                }
            }
        }
    };

    return <Line data={chartData} options={options} />;
};

export default LineChart2;